/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StaffBacklogMetricFromJSON, StaffBacklogMetricToJSON, } from './StaffBacklogMetric';
/**
 * Check if a given object implements the StaffPlatformMetrics interface.
 */
export function instanceOfStaffPlatformMetrics(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffPlatformMetricsFromJSON(json) {
    return StaffPlatformMetricsFromJSONTyped(json, false);
}
export function StaffPlatformMetricsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'newUsers': !exists(json, 'newUsers') ? undefined : json['newUsers'],
        'newIncidentReports': !exists(json, 'newIncidentReports') ? undefined : json['newIncidentReports'],
        'pendingModeration': !exists(json, 'pendingModeration') ? undefined : StaffBacklogMetricFromJSON(json['pendingModeration']),
        'openBounties': !exists(json, 'openBounties') ? undefined : StaffBacklogMetricFromJSON(json['openBounties']),
        'pendingTakedowns': !exists(json, 'pendingTakedowns') ? undefined : StaffBacklogMetricFromJSON(json['pendingTakedowns']),
    };
}
export function StaffPlatformMetricsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'newUsers': value.newUsers,
        'newIncidentReports': value.newIncidentReports,
        'pendingModeration': StaffBacklogMetricToJSON(value.pendingModeration),
        'openBounties': StaffBacklogMetricToJSON(value.openBounties),
        'pendingTakedowns': StaffBacklogMetricToJSON(value.pendingTakedowns),
    };
}
